export type RegistrationReferralState = { kind: string; code?: string; linkCapturedAt?: string };

/** Server reason for an unknown/expired/used session; never a code verdict (F10). */
export const REGISTRATION_SESSION_INVALID = 'registration_session_invalid';

/** Server reason for a link/click older than the Admin link validity (D-057). */
export const REFERRAL_LINK_EXPIRED = 'referral_link_expired';

/** True when validate-code (`reason`) or signup (`referral_reason`) reports a session fault. */
function rejectionReason(data: unknown): unknown {
  if (!data || typeof data !== 'object') return undefined;
  const body = data as { reason?: unknown; referral_reason?: unknown };
  const reason = body.reason ?? body.referral_reason;
  return Array.isArray(reason) ? reason[0] : reason;
}

export function isRegistrationSessionRejection(data: unknown): boolean {
  return rejectionReason(data) === REGISTRATION_SESSION_INVALID;
}

/** True when validate-code or signup reports that the link capture expired. */
export function isReferralLinkExpired(data: unknown): boolean {
  return rejectionReason(data) === REFERRAL_LINK_EXPIRED;
}

/** Null requires correction/retry/explicit opt-out before account creation. */
export function registrationReferralPayload(state: RegistrationReferralState, token: string | null) {
  if (state.kind === 'declined') return { referral_declined: true };
  if (state.kind === 'idle') return {};
  if (state.kind !== 'valid' || !state.code) return null;
  return {
    referral_code: state.code,
    ...(token ? { referral_token: token } : {}),
    ...(state.linkCapturedAt ? { referral_link_captured_at: state.linkCapturedAt } : {}),
  };
}
